import { render, staticRenderFns } from "./AbsenceStatistics.vue?vue&type=template&id=f6549b14&"
import script from "./AbsenceStatistics.vue?vue&type=script&lang=js&"
export * from "./AbsenceStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports